import isEqual from "lodash.isequal"
import { createActions, createReducer } from "reduxsauce"
import Immutable from "seamless-immutable"

import { preferencesSuccess } from "../../User/redux/user.actions"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getRequestsGiftsRequest: ["payload"], // payload: { params }
  getRequestsGiftsSuccess: ["payload"], // payload: { data }

  requestsGiftsFailure: ["payload"], // payload: { errors }

  clearRequestsGiftsFilters: null,
  requestsGiftsSetProp: ["key", "value"],

  logout: null
})

export const RequestsGiftsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

const columnsAdmin = [
  // {field_id: 'gift_type', label: 'Type', active: true},
  { field_id: "created_timestamp", label: "Created date", active: true },
  { field_id: "user_full_name", label: "User full name", active: true },
  { field_id: "user_email", label: "User email", active: true },
  { field_id: "amount", label: "Sum", active: true },
  { field_id: "admin_name", label: "Admin name", active: true }
]

export const INITIAL_STATE = Immutable({
  fetching: false,
  result: {
    count: 0,
    next: null,
    previous: null,
    results: []
  },

  defaultColumnsAdmin: [...columnsAdmin],
  columnsAdmin: [...columnsAdmin],

  filtersLastUpd: null,
  filters: {
    created_timestamp: null,
    user_full_name: [],
    user_email: [],
    amount: { min: null, max: null, type: null }
    // amount: null,
    // gift_type: [],
  },

  // visibleFiltersAdmin: {type: true, user_email: true, user_full_name: true},
  visibleFiltersAdmin: { user_email: true, user_full_name: true }
})

/* ------------- Selectors ------------- */
export const selectAreFiltersDefault = (state) =>
  isEqual(state.requestsIntegrations.filters, INITIAL_STATE.filters)

/* ------------- Functions for reducer cases ------------- */
const getRequestsGiftsRequest = (state) => state.merge({ fetching: true })
const getRequestsGiftsSuccess = (state, { payload: result }) => {
  if (result.results) {
    return state.merge({ fetching: false, result })
  } else {
    return state.merge({
      fetching: false,
      result: {
        count: result?.length || 0,
        results: result
      }
    })
  }
}

const requestsGiftsFailure = (state) => state.merge({ fetching: false })

export const requestsGiftsSetProp = (state, { key, value }) => {
  const obj = {}
  if (["filters", "visibleFilters", "visibleFiltersAdmin"]?.includes(key)) {
    if (key === "filters") obj.filtersLastUpd = new Date().getTime()
    obj[key] = { ...state?.[key], ...value }
  } else {
    obj[key] = value
  }
  return state.merge(obj)
}

export const clearRequestsGiftsFilters = (state) => {
  return state.merge({ filters: INITIAL_STATE.filters })
}

const logout = (state) => {
  return state.merge({
    ...INITIAL_STATE,
    filters: state.filters,
    columnsAdmin: state.columnsAdmin,
    visibleFiltersAdmin: state.visibleFiltersAdmin
  })
}

// Bump when the shape of the saved `{ version, filters, columnsAdmin, visibleFiltersAdmin }`
// payload changes.
export const REQUESTS_GIFTS_PREFERENCES_VERSION = 1

const applyPreferences = (state, { payload }) => {
  const preference = payload?.["requests-gifts"]?.data
  if (!preference || preference.version !== REQUESTS_GIFTS_PREFERENCES_VERSION) return state
  if (!preference.filters || !preference.columnsAdmin || !preference.visibleFiltersAdmin)
    return state

  return state.merge({
    filters: preference.filters,
    columnsAdmin: preference.columnsAdmin,
    visibleFiltersAdmin: preference.visibleFiltersAdmin
  })
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_REQUESTS_GIFTS_REQUEST]: getRequestsGiftsRequest,
  [Types.GET_REQUESTS_GIFTS_SUCCESS]: getRequestsGiftsSuccess,

  [Types.REQUESTS_GIFTS_FAILURE]: requestsGiftsFailure,

  [Types.CLEAR_REQUESTS_GIFTS_FILTERS]: clearRequestsGiftsFilters,

  [Types.REQUESTS_GIFTS_SET_PROP]: requestsGiftsSetProp,

  [Types.LOGOUT]: logout,

  [preferencesSuccess.type]: applyPreferences
})
